import React from "react";
import PropTypes from "prop-types";
import SectionTitle from "../../../components/section-title";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Navigation } from "swiper";
import HomeData from "../../../data/home.json";
import Testimonial from "../../../components/testimonial";

SwiperCore.use([Navigation]);
const TestimonialContainer = ({ type }) => {
    const data = type === "mission" ? HomeData[4] : HomeData[6];
    const swiperOption = {
        loop: true,
        slidesPerView: 2,
        spaceBetween: 30,
        autoplay: {
            delay: 2500,
            disableOnInteraction: false,
        },
        breakpoints: {
            0: {
                slidesPerView: 1,
                spaceBetween: 20,
            },
            576: {
                slidesPerView: 1,
                spaceBetween: 30,
            },
            768: {
                slidesPerView: 2,
                spaceBetween: 30,
            },
        },
        navigation: {
            nextEl: `.testimonial-carousel.${type} .swiper-button-next`,
            prevEl: `.testimonial-carousel.${type} .swiper-button-prev`,
        },
    };
    return (
        <div className="section">
            <div className="container">
                <div className="testimonial-wrapper section-padding">
                    <SectionTitle
                        classOption="section-title-2"
                        title={"Company " + type}
                    />
                    <div
                        className={`testimonial-carousel ${type}`}
                        data-aos="fade-up"
                        data-aos-duration="1200"
                    >
                        <Swiper {...swiperOption}>
                            {data.testimonial &&
                                data.testimonial.map((single, i) => {
                                    return (
                                        <SwiperSlide key={i}>
                                            <Testimonial
                                                key={i}
                                                data={single}
                                            />
                                        </SwiperSlide>
                                    );
                                })}
                        </Swiper>
                        <div className="swiper-button-prev">
                            <i className="icofont-thin-left"></i>
                        </div>
                        <div className="swiper-button-next">
                            <i className="icofont-thin-right"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

TestimonialContainer.propTypes = {
    // Specify the types for each prop
    type: PropTypes.string, // Example: string
};

export default TestimonialContainer;
